const CART = '[CART]';

export const SET_CART = `${CART} SET`;

export const setCart = data => ({
    type: SET_CART,
    payload: {
        data
    }
});
